function handleSelectOption(e, dropdown) {
  e.preventDefault();

  const selectedOption = e.target;
  const selectedOptionValue = selectedOption.dataset.value;
  const selectedOptionLabel = selectedOption.textContent;

  const dropdownToggle = dropdown.querySelector('.dropdown-toggle');
  const dropdownToggleText = dropdownToggle.querySelector('.btn-text');
  const dropdownOptions = dropdown.querySelectorAll('.dropdown-item');

  const hiddenInput = document.getElementById(`${dropdownToggle.id}-value`);

  dropdownToggle.dataset.text = selectedOptionValue;

  // Update Dropdown Toggle button w/ selected value
  dropdownToggleText.textContent = selectedOptionLabel;
  dropdownToggle.dataset.hasValue = !!selectedOptionValue;

  // Update selected dropdown item
  dropdownOptions.forEach((option) => option.classList.remove('selected'));
  selectedOption.classList.add('selected');

  // Update value of hidden input (if one exists)
  if (hiddenInput) {
    hiddenInput.value = selectedOptionValue;
    hiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

export function initializeSelectDropdown() {
  const selectDropdowns = Array.from(
    document.querySelectorAll('.select-dropdown')
  );
  selectDropdowns.forEach((selectDropdown) => {
    const selectOptions = selectDropdown.querySelectorAll('.dropdown-item');

    selectOptions.forEach((selectOption) => {
      selectOption.addEventListener('click', (e) =>
        handleSelectOption(e, selectDropdown)
      );
    });
  });
}
